"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-non-null-assertion */
// @ts-nocheck
const Overlay_1 = __importDefault(require("ol/Overlay"));
const ol_1 = require("ol");
class OverlayBuilder {
    constructor(map = new ol_1.Map()) {
        this.map = map;
    }
    findOverlay(elementId) {
        return this.map.getOverlays().getArray().find((overlay) => {
            return overlay.getElement() === document.getElementById(elementId);
        });
    }
    removeOverlay(elementId) {
        const overlay = this.findOverlay(elementId);
        if (overlay)
            this.map.removeOverlay(overlay);
    }
    addOverlay(elementId, coordinates, position) {
        const existingOverlay = this.findOverlay(elementId);
        if (existingOverlay) {
            existingOverlay.setPosition(coordinates);
            const element = existingOverlay.getElement();
            if (element)
                element.style.display = 'block';
        }
        else {
            const domItem = document.getElementById(elementId);
            const tooltip = new Overlay_1.default({
                element: domItem,
                offset: [0, -10],
                positioning: position || 'bottom-center',
                stopEvent: true,
            });
            const tooltipElement = tooltip.getElement();
            if (tooltipElement)
                tooltipElement.style.display = 'block';
            tooltip.setPosition(coordinates);
            this.map.addOverlay(tooltip);
        }
    }
    visibilityOverlay(elementId, show) {
        const existingOverlay = this.findOverlay(elementId);
        if (existingOverlay) {
            const opacity = show ? 1 : 0;
            const existingOverlayElement = existingOverlay.getElement();
            if (existingOverlayElement)
                existingOverlayElement.style.opacity = opacity.toString();
            opacity === 0 ? existingOverlay.setPosition(undefined) : '';
            existingOverlay.set('stopEvent', false);
        }
    }
}
exports.default = OverlayBuilder;
